import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AffiliateProgramPromoCodesCreateModule } from '@modules/affiliate-program-promo-codes/submodules/create/AffiliateProgramPromoCodesCreateModule';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PARTNERSHIP_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  AFFILIATE_PROGRAM_PROMO_CODES_LIST_ROUTE_NAME,
  AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS,
  AFFILIATE_PROGRAM_PROMO_CODES_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_PROGRAM_PROMO_CODES,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliateProgramPromoCodesModule extends AppModule {
  protected submodules = [
    new AffiliateProgramPromoCodesCreateModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: AFFILIATE_PROGRAM_PROMO_CODES_ROUTE_NAME,
      path: 'promo-codes',
      permission: AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'AffiliateProgramPromoCodesListPage',
    });

    // Promo codes list
    router.addChildRoute(AFFILIATE_PROGRAM_PROMO_CODES_ROUTE_NAME, {
      name: AFFILIATE_PROGRAM_PROMO_CODES_LIST_ROUTE_NAME,
      path: '',
      permission: AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS.SHOW,
      component: () => import('./pages/AffiliateProgramPromoCodesListPage/AffiliateProgramPromoCodesListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERSHIP_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'ADMIN_PARTNERSHIP_PROMO_CODES'),
      to: {
        name: AFFILIATE_PROGRAM_PROMO_CODES_LIST_ROUTE_NAME,
      },
      permission: AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS.SHOW,
      id: AFFILIATE_PROGRAM_PROMO_CODES_LIST_ROUTE_NAME,
      order: 20,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATE_PROGRAM_PROMO_CODES, getTranslationKeys);
  }
}
